// extracted by mini-css-extract-plugin
module.exports = {"sponsors":"sponsors_sponsors__3-6-j"};